import { render, staticRenderFns } from "./UpdateCustomerProjectBriefPopUp.vue?vue&type=template&id=5133ff20&scoped=true&"
import script from "./UpdateCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerProjectBriefPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerProjectBriefPopUp.vue?vue&type=style&index=0&id=5133ff20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133ff20",
  null
  
)

export default component.exports